import { render, staticRenderFns } from "./UserPrivileges.vue?vue&type=template&id=bebb5bd8&"
import script from "./UserPrivileges.vue?vue&type=script&lang=ts&"
export * from "./UserPrivileges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports